import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';

gsap.registerPlugin(ScrollTrigger);

const Stories = () => {
  const sectionRef = useRef(null);
  const cardsRef = useRef([]);

  const stories = [
    {
      name: 'Sarah Johnson',
      quote: 'Dough-nate made our school fundraiser so special! The kids loved the donuts, and knowing we were helping the local food bank made it even better.',
      eventType: 'School Fundraiser',
      image: 'https://images.unsplash.com/photo-1589754293549-4c0585a12de5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHxkaXZlcnNlJTIwY29tbXVuaXR5JTIwcGVvcGxlJTIwc21pbGluZ3xlbnwwfHx8fDE3NjE1Nzg4Nzl8MA&ixlib=rb-4.1.0&q=85'
    },
    {
      name: 'Michael Chen',
      quote: 'We ordered for our company meeting and chose to support animal welfare. A sweeter way to give indeed! Everyone asked where we got them.',
      eventType: 'Corporate Event',
      image: 'https://images.unsplash.com/photo-1629160474797-b5218fc7a8d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxkaXZlcnNlJTIwY29tbXVuaXR5JTIwcGVvcGxlJTIwc21pbGluZ3xlbnwwfHx8fDE3NjE1Nzg4Nzl8MA&ixlib=rb-4.1.0&q=85'
    },
    {
      name: 'Priya Patel',
      quote: 'Perfect for our community gathering! We supported a local homeless shelter and the donuts were absolutely delicious. Win-win!',
      eventType: 'Community Gathering',
      image: 'https://images.unsplash.com/photo-1668156360316-ffa717db468c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxkaXZlcnNlJTIwY29tbXVuaXR5JTIwcGVvcGxlJTIwc21pbGluZ3xlbnwwfHx8fDE3NjE1Nzg4Nzl8MA&ixlib=rb-4.1.0&q=85'
    }
  ];

  useEffect(() => {
    const ctx = gsap.context(() => {
      cardsRef.current.forEach((card, index) => {
        const direction = index % 2 === 0 ? -50 : 50;
        gsap.fromTo(card,
          { x: direction, opacity: 0, scale: 0.9 },
          {
            x: 0,
            opacity: 1,
            scale: 1,
            duration: 0.8,
            ease: 'power3.out',
            scrollTrigger: {
              trigger: card,
              start: 'top 80%',
              toggleActions: 'play none none none'
            }
          }
        );
      });
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  // Section hidden by request — return null to prevent rendering on the site.
  // To re-enable, replace this line with the previous JSX returned by the component.
  return null;
};

export default Stories;